/**
 * Mapeo cosmético PB-<cliente>-NNN → AROC-P-NNN (DF7-13).
 *
 * Internamente la DB y el código usan el ID real (`PB-tilatina-001-...`).
 * En la UI siempre se muestra el `display_id` (AROC-P-NNN). Este componente
 * encapsula la lógica para que cualquier render del playbook_id pase por
 * ella.
 */

const EXPLICIT_MAP: Record<string, string> = {
  "PB-tilatina-001-sonicwall-failover-check": "AROC-P-001",
  // Fase 8 (DF8-05): protocolos del catálogo Tilatina con display explícito.
  // (PB-005 retirado en Fase 1 de la auditoría de autorremediaciones.)
  "PB-tilatina-002-asterisk-trunk-restart": "AROC-P-002",
  "PB-tilatina-003-vms-service-restart": "AROC-P-003",
  "PB-tilatina-004-route-admin-restore": "AROC-P-004",
};

const PB_REGEX = /^PB-[a-z0-9]+-(\d{3})(?:-[a-z0-9-]+)?$/;

export function toDisplayId(internalId: string): string {
  if (internalId in EXPLICIT_MAP) return EXPLICIT_MAP[internalId];
  const m = PB_REGEX.exec(internalId);
  if (m) return `AROC-P-${m[1]}`;
  return internalId;
}

interface Props {
  internalId: string;
  showInternal?: boolean;
}

export function ProtocolIdDisplay({ internalId, showInternal = false }: Props) {
  const display = toDisplayId(internalId);
  if (showInternal && display !== internalId) {
    return (
      <span title={internalId}>
        <span className="font-mono">{display}</span>
        <span className="ml-1 text-xs text-muted-foreground">({internalId})</span>
      </span>
    );
  }
  return <span className="font-mono" title={internalId}>{display}</span>;
}
